import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/css/index.css'
import './utils/rem'
import axios from 'axios';
import Ajax from 'axios';
import MetaInfo from 'vue-meta-info'
import i18n from './i18n'

Vue.use(MetaInfo)

import {Lazyload} from 'vant';

Vue.use(Lazyload);

Vue.prototype.$ajax = Ajax;
Vue.use(Lazyload, {
    lazyComponent: true,
});
Vue.use(Vant);
// axios.defaults.baseURL = `//47.251.77.185/`;
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || '';

Vue.prototype.$axios = axios
// http request 拦截器
axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        const generalize = localStorage.getItem('generalize')
        if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = 'Bearer ' + token;  //请求头加上token
        }
        if (generalize) {
            config.headers.Generalize = generalize;
        }
        return config
    },
    err => {
        return Promise.reject(err)
    })
// http response 拦截器 — 翻译后端消息码
axios.interceptors.response.use(
    res => {
        const msg = res.data && res.data.message
        if (msg && i18n.te('api.' + msg)) {
            res.data.message = i18n.t('api.' + msg)
        }
        return res
    },
    err => {
        const msg = err.response && err.response.data && err.response.data.message
        if (msg && i18n.te('api.' + msg)) {
            err.response.data.message = i18n.t('api.' + msg)
        }
        return Promise.reject(err)
    })
// 全局时间过滤器 — 相对时间 (e.g. "5 min ago")
Vue.filter('timeAgo', val => {
    if (!val) return ''
    const d = typeof val === 'number' ? new Date(val * 1000) : new Date(val.replace(' ', 'T'))
    const diff = Math.floor((Date.now() - d.getTime()) / 1000)
    const isZh = i18n.locale.startsWith('zh')
    if (diff < 60) return isZh ? diff + '秒前' : diff + 's ago'
    if (diff < 3600) return isZh ? Math.floor(diff / 60) + '分钟前' : Math.floor(diff / 60) + 'min ago'
    if (diff < 86400) return isZh ? Math.floor(diff / 3600) + '小时前' : Math.floor(diff / 3600) + 'h ago'
    if (diff < 2592000) return isZh ? Math.floor(diff / 86400) + '天前' : Math.floor(diff / 86400) + 'd ago'
    if (diff < 31536000) return isZh ? Math.floor(diff / 2592000) + '月前' : Math.floor(diff / 2592000) + 'mo ago'
    return isZh ? Math.floor(diff / 31536000) + '年前' : Math.floor(diff / 31536000) + 'y ago'
})
// 全局时间过滤器 — 详细时间 (e.g. "PM 3:30", "Yesterday", "1/15")
Vue.filter('timeDetail', val => {
    if (!val) return ''
    const d = typeof val === 'number' ? new Date(val * 1000) : new Date(val.replace(' ', 'T'))
    const now = new Date()
    const pad = n => String(n).padStart(2, '0')
    const h = d.getHours(), m = pad(d.getMinutes())
    const isToday = d.toDateString() === now.toDateString()
    const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1)
    const isYesterday = d.toDateString() === yesterday.toDateString()
    const isZh = i18n.locale.startsWith('zh')
    if (isToday) {
        if (isZh) return (h >= 12 ? '下午' : '早上') + (h > 12 ? h - 12 : h || 12) + ':' + m
        const period = h >= 12 ? 'PM' : 'AM'
        return period + ' ' + (h > 12 ? h - 12 : h || 12) + ':' + m
    } else if (isYesterday) {
        const h12 = h > 12 ? h - 12 : h || 12
        return isZh ? '昨天 ' + h12 + ':' + m : 'Yesterday ' + h12 + ':' + m
    } else if (d.getFullYear() === now.getFullYear()) {
        return isZh ? (d.getMonth() + 1) + '月' + d.getDate() + '日' : (d.getMonth() + 1) + '/' + d.getDate()
    }
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
})
// 时间过滤器
// 全局时间过滤器
Vue.filter("formatAdminTime", val => {
    // 在后台返回的时间基础上增加8小时
    if (val.toString().length === 10) val *= 1000;
    const date = new Date(val);
    // date.setHours(date.getHours() + 8);
    // 年月日
    const y = date.getFullYear();
    const m = (date.getMonth() + 1 + "").padStart(2, "0");
    const d = (date.getDate() + "").padStart(2, "0");
    // 时分秒
    const hh = (date.getHours() + "").padStart(2, "0");
    const mm = (date.getMinutes() + "").padStart(2, "0");
    const ss = (date.getSeconds() + "").padStart(2, "0");
    // 返回时间格式
    return `${y}-${m}-${d}`;
});
Vue.config.productionTip = false

function initGuestToken() {
  if (localStorage.getItem('token')) return Promise.resolve()
  let deviceId = localStorage.getItem('guest_device_id')
  if (!deviceId) {
    deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
    localStorage.setItem('guest_device_id', deviceId)
  }
  return axios.post('/api/guest/token', { device_id: deviceId })
    .then(res => {
      localStorage.setItem('token', res.data.data.token)
      localStorage.setItem('is_guest', '1')
    })
    .catch(() => {})
}

initGuestToken().then(() => {
  new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
  }).$mount('#app')
})
